export default __webpack_public_path__ + "static/media/blueUpdateProfile.9409122b.svg";